import OrdersPage from './OrdersPage';
import ordersPageReducer from './reducer';

export { ordersPageReducer };
export default OrdersPage;
